export const UrlRepository = {
  SUCCESSFUL_SUBMISSION_TRIAL_EN: "https://cigotracker.com/public/successful-submission-trial/",
  SUCCESSFUL_SUBMISSION_TRIAL_FR: "https://cigotracker.com/page-de-soumission-essai-gratuit/",
  SUCCESSFUL_SUBMISSION_TRIAL_ES: "https://cigotracker.com/pagina-de-presentacion-prueba-gratuita/",
  SUCCESSFUL_SUBMISSION_TRIAL_VOLUME_EN: "https://cigotracker.com/public/successful-submission-trial-volume/",
  SUCCESSFUL_SUBMISSION_TRIAL_VOLUME_FR: "https://cigotracker.com/page-de-soumission-essai-gratuit-volume/",
  SUCCESSFUL_SUBMISSION_TRIAL_VOLUME_ES: "https://cigotracker.com/pagina-de-presentacion-prueba-gratuita-volumen/",
};